import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import CriticalDate from './critical_date';
import Currency from './currency';
import Numeric from './numeric';
import Percentage from './percentage';
import Select from './select';
import Text from './text';
import TextArea from './textarea';

const componentsByType = {
  currency: Currency,
  date: CriticalDate,
  number: Numeric,
  percentage: Percentage,
  textarea: TextArea,
  url_collection: TextArea,
};

export function CustomFields({ category, forDates, fields }) {
  const configsByName = useMemo(() => {
    const configsByName = {};

    for (const name in fields) {
      const field = fields[name];
      if (field.custom) {
        const isDate = field.type === 'date';
        if (forDates && isDate) {
          configsByName[name] = { component: CriticalDate };
        } else if (!forDates && !isDate && field.category === category) {
          if (field.options) {
            configsByName[name] = { component: Select };
          } else {
            configsByName[name] = { component: componentsByType[field.type] || Text };
          }
        }
      }
    }

    return configsByName;
  }, [category, fields]);

  return <>
    {Object.keys(configsByName).map((name) => {
      const config = configsByName[name];
      const Component = config.component;
      return <Component key={name} name={name} {...config.props} />;
    })}
  </>;
}

CustomFields.propTypes = {
  category: PropTypes.string,
  fields: PropTypes.objectOf(PropTypes.shape({
    category: PropTypes.string,
    options: PropTypes.array,
    type: PropTypes.bool,
  })).isRequired,
  forDates: PropTypes.bool,
};

const mapStateToProps = state => ({
  fields: state.fields,
});

export default connect(mapStateToProps)(CustomFields);
